import React from 'react';
import Styled from 'styled-components';
import Box from 'components/Box';
import ForwardIcon from 'mdi-react/ArrowRightCircleOutlineIcon';
import { Typography } from '@material-ui/core';
import * as moment from 'moment';

export default function NewsPostCard({ post, push, anon = true, className }) {
  return (
    <NewsCard boxShadow={10} style={{ padding: '16px' }} className={className}>
      <div style={{ padding: '10' }} onClick={() => push()}>
        <Col style={{ padding: 5, maxWidth: '500px' }}>
          <AvatarName>{post.title}</AvatarName>
          <Typography variant="caption">
            {moment(post.time).format('DD-MM-YYYY')}
          </Typography>
          <Row style={{ marginTop: '5px' }}>
            {post.imageUrl && (
              <img
                src={post.imageUrl}
                alt=""
                style={{
                  height: '150px',
                  width: '200px',
                  margin: '6px 16px 8px 5px'
                }}
              />
            )}

            <Typography
              style={{ flex: '1', marginLeft: '6px', marginBottom: '7px' }}
            >
              {post.detail.substring(0, 100)}...
              <span style={{ marginTop: '9px' }}>
                <ReadMore onClick={push}>
                  <span>Read more</span>
                  <span height="100%">
                    <ForwardIconStyled />
                  </span>
                </ReadMore>
              </span>
            </Typography>
          </Row>
        </Col>
        <Row>
          <Typography>{post.message}</Typography>
        </Row>
      </div>
    </NewsCard>
  );
}

const AvatarName = Styled(Typography).attrs({
  variant: 'h4'
})`
  color: ${props => props.theme.palette.primary['500']};
  line-height: 2;
  display: inline;
`;

const NewsCard = Styled(Box)`
  && {
    margin:0px;
    padding:0px;
    padding-bottom: 8px;
    
  }
`;

const Row = Styled.div`
  display:flex;
  flex-direction:row;
`;

const Col = Styled.div`
  text-align:start;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
`;

const ReadMore = Styled(Typography).attrs({
  variant: 'caption'
})`
  cursor:pointer;
  display:flex;
`;

const ForwardIconStyled = Styled(ForwardIcon)`
  &&{
    padding-left:4px;
    color:rgba(0,0,0,0.87);
  }
`;
